import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { catchError, finalize, Observable } from 'rxjs';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  jwt: string | null = ""

  constructor(private authService: AuthService, private router: Router) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    if (!req.url.includes("/auth/accessToken") && !req.url.includes("/blog") && !req.url.includes("/pricing") && !req.url.includes("/faq") && !req.url.includes("/seoTools")) {
      this.jwt = localStorage.getItem("ut");

      if (this.jwt == null) {
        //this.router.navigateByUrl("/signin");
        location.href = "/signin";
      }
      try {
        var jwtParsed = this.parseJwt(this.jwt);

        if (jwtParsed != null && jwtParsed.exp != null && !this.istokenValid(jwtParsed.exp)) {
          localStorage.removeItem("ut");
          localStorage.removeItem("plan");
          //this.router.navigateByUrl("/signin");
          location.href = "/signin";
        }

        const authReq = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.jwt)
        })

        // show loader here
        return next.handle(authReq).pipe(
          catchError((err: any) => {

            if (err.status == 401) {
              localStorage.removeItem("ut");
              localStorage.removeItem("plan");
              //this.router.navigateByUrl("/signin");
              location.href = "/signin";
              return next.handle(req);
            }
            else
              throw (err);
          }),
          finalize(() => {
            // hide loader here

          }));
      } catch (e) {

        throw (e);
      }

    }
    else {
      // show loader here
      return next.handle(req);
    }

  }

  istokenValid(exp: any) {
    if (Date.now() >= exp * 1000) {
      return false;
    }

    return true;
  }

  parseJwt(token: any) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
}
